import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {StatsConfigService} from '../../services/stats-config.service';

const SELECT_VNA_STATS_CONFIG_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectConfigStatsComponent)
};

@Component({
  selector: 'app-select-config-stats',
  template: `
      <ngx-select [items]="configs" [(ngModel)]="config" [optionValueField]="valueField" [optionTextField]="textField" (select)="selected($event)" >
          <ng-template ngx-select-option let-option let-text="text">
              {{ option.data.name }} <br />
              <small>Portal / Lang: <strong>{{option.data.lang}}-{{option.data.portal}}</strong> -- Provider: <strong>{{ option.data.provider }}</strong> -- Default: <strong>{{ option.data.is_default }}</strong></small>
          </ng-template>
          <ng-template ngx-select-option-selected let-option let-text="text">
              {{ option.data.name }}
          </ng-template>
      </ngx-select>
      `,
  styleUrls: ['./select-config-stats.component.scss'],
    providers: [SELECT_VNA_STATS_CONFIG_VALUE_ACCESSOR]
})
export class SelectConfigStatsComponent implements OnInit, ControlValueAccessor {

    @Input() valueField: string = 'pk';
    @Input() textField: string = 'name';

    configs: Object;
    _config: number;

    constructor(private stats: StatsConfigService) { }

    selected(value: any) {
        this.propagateChange(this._config);
    }


    get config(): any { return this._config; };

    set config(v: any) {
        this._config = v;
        this.propagateChange(this._config);
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(value: any): void {
        this._config = value;
    }

    ngOnInit() {
        this.stats.getStatsConfigs().subscribe(
          (result) => {
                this.configs = result;
            }
        )
  }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/stats/components/select-config-stats/select-config-stats.component.ts